import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    key: String,
    id: String,
    type: String,
  }
}
